export const LOGIN_SAP_LISTAR_BEGIN = 'LOGIN_SAP_LISTAR_BEGIN';
export const LOGIN_SAP_LISTAR_SUCCESS = 'LOGIN_SAP_LISTAR_SUCCESS';
export const LOGIN_SAP_LISTAR_FAILURE = 'LOGIN_SAP_LISTAR_FAILURE';
export const LOGIN_SAP_LISTAR_DISMISS_ERROR = 'LOGIN_SAP_LISTAR_DISMISS_ERROR';
export const LOGIN_SAP_BUSCAR_LOGIN_SAP_BEGIN = 'LOGIN_SAP_BUSCAR_LOGIN_SAP_BEGIN';
export const LOGIN_SAP_BUSCAR_LOGIN_SAP_SUCCESS = 'LOGIN_SAP_BUSCAR_LOGIN_SAP_SUCCESS';
export const LOGIN_SAP_BUSCAR_LOGIN_SAP_FAILURE = 'LOGIN_SAP_BUSCAR_LOGIN_SAP_FAILURE';
export const LOGIN_SAP_BUSCAR_LOGIN_SAP_DISMISS_ERROR = 'LOGIN_SAP_BUSCAR_LOGIN_SAP_DISMISS_ERROR';
export const LOGIN_SAP_INICIALIZAR_REGISTRO_LOGIN_SAP = 'LOGIN_SAP_INICIALIZAR_REGISTRO_LOGIN_SAP';
export const LOGIN_SAP_SALVAR_BEGIN = 'LOGIN_SAP_SALVAR_BEGIN';
export const LOGIN_SAP_SALVAR_SUCCESS = 'LOGIN_SAP_SALVAR_SUCCESS';
export const LOGIN_SAP_SALVAR_FAILURE = 'LOGIN_SAP_SALVAR_FAILURE';
export const LOGIN_SAP_SALVAR_DISMISS_ERROR = 'LOGIN_SAP_SALVAR_DISMISS_ERROR';
export const LOGIN_SAP_DELETAR_BEGIN = 'LOGIN_SAP_DELETAR_BEGIN';
export const LOGIN_SAP_DELETAR_SUCCESS = 'LOGIN_SAP_DELETAR_SUCCESS';
export const LOGIN_SAP_DELETAR_FAILURE = 'LOGIN_SAP_DELETAR_FAILURE';
export const LOGIN_SAP_DELETAR_DISMISS_ERROR = 'LOGIN_SAP_DELETAR_DISMISS_ERROR';
export const LOGIN_SAP_LISTAR_AGENDAMENTO_RPA_BEGIN = 'LOGIN_SAP_LISTAR_AGENDAMENTO_RPA_BEGIN';
export const LOGIN_SAP_LISTAR_AGENDAMENTO_RPA_SUCCESS = 'LOGIN_SAP_LISTAR_AGENDAMENTO_RPA_SUCCESS';
export const LOGIN_SAP_LISTAR_AGENDAMENTO_RPA_FAILURE = 'LOGIN_SAP_LISTAR_AGENDAMENTO_RPA_FAILURE';
export const LOGIN_SAP_LISTAR_AGENDAMENTO_RPA_DISMISS_ERROR = 'LOGIN_SAP_LISTAR_AGENDAMENTO_RPA_DISMISS_ERROR';
export const LOGIN_SAP_SALVAR_AGENDAMENTO_RPA_BEGIN = 'LOGIN_SAP_SALVAR_AGENDAMENTO_RPA_BEGIN';
export const LOGIN_SAP_SALVAR_AGENDAMENTO_RPA_SUCCESS = 'LOGIN_SAP_SALVAR_AGENDAMENTO_RPA_SUCCESS';
export const LOGIN_SAP_SALVAR_AGENDAMENTO_RPA_FAILURE = 'LOGIN_SAP_SALVAR_AGENDAMENTO_RPA_FAILURE';
export const LOGIN_SAP_SALVAR_AGENDAMENTO_RPA_DISMISS_ERROR = 'LOGIN_SAP_SALVAR_AGENDAMENTO_RPA_DISMISS_ERROR';
export const LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_BEGIN = 'LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_BEGIN';
export const LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_SUCCESS = 'LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_SUCCESS';
export const LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_FAILURE = 'LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_FAILURE';
export const LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_DISMISS_ERROR = 'LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/login-sap/redux/constants.js